import React from 'react';
import { Box } from '@mui/material';
import { mergeSx } from './utils/mergeSx';

/**
 * Full-width page container for private app views.
 * Matches Campaign list layout — no max-width cap on large screens.
 * Pass `maxWidth` only for intentionally narrow pages (e.g. profile forms).
 */
export default function PageShell({ children, maxWidth, sx }) {
  return (
    <Box
      sx={mergeSx(
        {
          width: '100%',
          ...(maxWidth != null ? { maxWidth, mx: 'auto' } : {}),
        },
        sx,
      )}
    >
      {children}
    </Box>
  );
}
